export default function Services() {
  const services = [
    {
      id: 1,
      title: 'Thu Mua Sắt Thép',
      icon: 'ri-hammer-line',
      description: 'Sắt phế liệu, thép xây dựng, sắt thép công nghiệp',
      image: 'https://public.readdy.ai/ai/img_res/0b47f31bb36cdbebc54b5f64d48d93a8.jpg',
      color: 'from-orange-600 to-red-700'
    },
    {
      id: 2,
      title: 'Thu Mua Nhôm',
      icon: 'ri-box-3-line',
      description: 'Nhôm phế liệu các loại, nhôm thanh, nhôm tấm',
      image: 'https://readdy.ai/api/search-image?query=pile%20of%20crushed%20aluminum%20cans%20aluminum%20profiles%20scrap%20metal%20collected%20in%20Vietnamese%20recycling%20yard%20outdoor%20realistic%20photo%20natural%20sunlight%20dusty%20ground%20Southeast%20Asia&width=600&height=400&seq=vn-aluminum-scrap-102&orientation=landscape',
      color: 'from-gray-400 to-gray-500'
    },
    {
      id: 3,
      title: 'Thu Mua Đồng',
      icon: 'ri-copper-coin-line',
      description: 'Đồng đỏ, đồng vàng, dây cáp đồng',
      image: 'https://readdy.ai/api/search-image?query=copper%20wire%20cables%20scrap%20metal%20pile%20reddish%20orange%20color%20Vietnamese%20recycling%20collection%20yard%20outdoor%20realistic%20close%20up%20photo%20natural%20light%20Southeast%20Asia&width=600&height=400&seq=vn-copper-scrap-103&orientation=landscape',
      color: 'from-orange-500 to-orange-600'
    },
    {
      id: 4,
      title: 'Thu Mua Inox',
      icon: 'ri-contrast-2-line',
      description: 'Inox 304, 316, inox công nghiệp',
      image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20inox%20scrap%20sheets%20pipes%20kitchen%20equipment%20piled%20in%20Vietnamese%20scrap%20collection%20yard%20outdoor%20realistic%20photo%20shiny%20silver%20metal%20natural%20sunlight&width=500&height=400&seq=vn-inox-scrap-104&orientation=landscape',
      color: 'from-slate-400 to-slate-500'
    },
    {
      id: 5,
      title: 'Thu Mua Máy Móc Cũ',
      icon: 'ri-settings-3-line',
      description: 'Máy móc, thiết bị công nghiệp cũ',
      image: 'https://readdy.ai/api/search-image?query=old%20used%20industrial%20machines%20motors%20generators%20electric%20equipment%20collected%20in%20Vietnamese%20factory%20yard%20for%20recycling%20realistic%20documentary%20photo%20natural%20light%20Southeast%20Asia&width=500&height=400&seq=vn-machine-scrap-105&orientation=landscape',
      color: 'from-yellow-600 to-amber-700'
    },
    {
      id: 6,
      title: 'Thu Mua Nhà Xưởng Thanh Lý',
      icon: 'ri-building-line',
      description: 'Thanh lý nhà xưởng, kho bãi, công trình',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20industrial%20warehouse%20factory%20building%20being%20dismantled%20workers%20collecting%20steel%20roof%20sheets%20beams%20demolition%20site%20realistic%20photo%20tropical%20environment%20natural%20daylight&width=500&height=400&seq=vn-factory-scrap-106&orientation=landscape',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Dịch Vụ Thu Mua<br />
            Phế Liệu <span className="text-teal-600">Chuyên Nghiệp</span>
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Chúng tôi thu mua đa dạng các loại phế liệu với giá cạnh tranh nhất thị trường
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {/* Large Card - Steel */}
          <div className="md:row-span-2 group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer hover:scale-[1.02]">
            <div className="relative h-full min-h-[600px]">
              <img
                src={services[0].image}
                alt={services[0].title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className={`w-16 h-16 bg-gradient-to-br ${services[0].color} rounded-2xl flex items-center justify-center mb-4 shadow-lg`}>
                  <div className="w-16 h-16 flex items-center justify-center">
                    <i className={`${services[0].icon} text-white text-3xl`}></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">{services[0].title}</h3>
                <p className="text-gray-200 text-sm">{services[0].description}</p>
              </div>
            </div>
          </div>

          {/* Small Cards - Top Row */}
          {services.slice(1, 3).map((service) => (
            <div key={service.id} className="group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer hover:scale-[1.02]">
              <div className="relative h-64">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className={`w-12 h-12 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center mb-3 shadow-lg`}>
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className={`${service.icon} text-white text-2xl`}></i>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-1">{service.title}</h3>
                  <p className="text-gray-200 text-xs">{service.description}</p>
                </div>
              </div>
            </div>
          ))}

          {/* Small Cards - Bottom Row */}
          {services.slice(3, 6).map((service) => (
            <div key={service.id} className="group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer hover:scale-[1.02]">
              <div className="relative h-64">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className={`w-12 h-12 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center mb-3 shadow-lg`}>
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className={`${service.icon} text-white text-2xl`}></i>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-1">{service.title}</h3>
                  <p className="text-gray-200 text-xs">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a href="tel:0909123456" className="inline-flex items-center gap-3 bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-full text-sm font-bold transition-all whitespace-nowrap shadow-lg hover:shadow-xl">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-lg"></i>
            </div>
            LIÊN HỆ BÁO GIÁ NGAY
          </a>
        </div>
      </div>
    </section>
  );
}